'use client'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { clickEvent } from '_libs/common/event-tracker/events'
import { navigateToPage } from '@marketplace-web/shared/browser'
import { VIEW_ISSUE_DETAILS_URL } from 'constants/routes'
import { ClickableElement } from 'constants/tracking/clickable-elements'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import {
  ConversationActionButton,
  ConversationActionProps,
} from '@marketplace-web/messaging/conversation-action-feature'

type Props = ConversationActionProps

const ViewIssueDetails = ({ primary, title, inverse, theme, size }: Props) => {
  const { track } = useTracking()

  const { conversation } = useConversationContext()
  const transactionId = conversation?.transaction?.id

  const trackViewIssueDetailsClick = () => {
    const targetDetails = {
      transaction_id: transactionId,
    }

    track(
      clickEvent({
        target: ClickableElement.ViewIssueDetails,
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  const handleClick = () => {
    if (!transactionId) return

    trackViewIssueDetailsClick()
    navigateToPage(VIEW_ISSUE_DETAILS_URL(transactionId))
  }

  if (!transactionId) return null

  return (
    <ConversationActionButton
      text={title}
      primary={primary}
      size={size}
      theme={theme}
      inverse={inverse}
      onClick={handleClick}
      testId="view-issue-details-action-button"
    />
  )
}

export default ViewIssueDetails
